export default __webpack_public_path__ + "static/media/aboutBgDec1.0cdec8e0.png";